import { render, staticRenderFns } from "./modifyPsw.vue?vue&type=template&id=280e34b0&"
import script from "./modifyPsw.vue?vue&type=script&lang=js&"
export * from "./modifyPsw.vue?vue&type=script&lang=js&"
import style0 from "./modifyPsw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports